import { useLenis } from "lenis/react";
import { ArrowRight } from "lucide-react";
import { MaskLine, FadeUp } from "@/components/Reveal";

const H = "font-display font-extrabold uppercase leading-[0.92] tracking-[-0.02em] [font-stretch:118%]";

export default function Hero() {
  const lenis = useLenis();

  const go = (e, href) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(href, { offset: -64, duration: 1.4 });
  };

  return (
    <section id="home" data-testid="hero-section" className="relative overflow-hidden bg-ink text-paper">
      <div className="mx-auto max-w-[1500px] px-6 pt-28 md:px-10 md:pt-36 lg:px-14">
        <FadeUp immediate y={16} className="flex items-center gap-3 border-b border-paper/15 pb-6">
          <span className="h-2 w-2 bg-accent" aria-hidden />
          <span className="text-[12px] font-bold uppercase tracking-[0.2em] text-paper">Lennon Global</span>
          <span className="ml-auto text-[12px] font-semibold uppercase tracking-[0.2em] text-paper/50">Los Angeles · Dubai · Global</span>
        </FadeUp>

        <div className="py-14 md:py-20">
          <h1>
              <MaskLine immediate delay={0.1} innerClassName={`${H} text-[10.5vw] text-paper sm:text-6xl md:text-[4.4vw]`}>
                Everyone talks
              </MaskLine>
              <MaskLine immediate delay={0.2} innerClassName={`${H} text-[10.5vw] text-paper sm:text-6xl md:text-[4.4vw]`}>
                about algorithms.
              </MaskLine>
              <MaskLine immediate delay={0.34} className="mt-3" innerClassName={`${H} text-[10.5vw] sm:text-6xl md:text-[4.4vw]`}>
                <span className="text-paper">I pay attention</span>
              </MaskLine>
              <MaskLine immediate delay={0.44} innerClassName={`${H} text-[10.5vw] sm:text-6xl md:text-[4.4vw]`}>
                <span className="text-accent">to people.</span>
              </MaskLine>
            </h1>

            <FadeUp immediate delay={0.55} y={24} className="mt-10 max-w-xl"><p className="text-lg font-semibold leading-snug text-paper md:text-xl">
                Creator partnerships for B2B companies moving at the speed of AI.
              </p>
              <p className="mt-4 text-base leading-relaxed text-paper/60">
                The relationships, market knowledge and team to move creator-led growth from opportunity to execution.
              </p>
              <a
                href="#contact"
                onClick={(e) => go(e, "#contact")}
                data-testid="hero-talk-cta"
                className="group mt-9 inline-flex items-center gap-3 bg-accent px-7 py-4 text-[13px] font-bold uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:bg-paper hover:text-ink"
              >
                Talk to Lennon
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </FadeUp>
        </div>
      </div>

      <FadeUp immediate delay={0.7} y={40}>
        <picture>
          <source media="(max-width: 640px)" srcSet="/assets/hero-summit-mobile.jpg" />
          <img
            src="/assets/hero-summit.jpg"
            alt="Drone light show spelling 1 Billion Followers Summit above the creator crowd in Dubai"
            data-testid="hero-summit-image"
            className="block h-auto w-full"
          />
        </picture>
      </FadeUp>
    </section>
  );
}
